module.exports = __webpack_public_path__ + "static/media/briales-BN.cd901b9f.svg";